import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Tiles } from '@rebass/layout';
export const title = 'Layout';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "rebasslayout"
    }}>{`@rebass/layout`}</h1>
    <p>{`Themeable layout components built with Rebass`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i @rebass/layout
`}</code></pre>
    <h2 {...{
      "id": "tiles"
    }}>{`Tiles`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Tiles width={[96, null, 128]}>
  <Image src={props.image} />
  <Image src={props.image} />
  <Image src={props.image} />
  <Image src={props.image} />
</Tiles>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Tiles columns={[2, null, 4]}>
  <Image src={props.image} />
  <Image src={props.image} />
  <Image src={props.image} />
  <Image src={props.image} />
</Tiles>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      